import React, { useState } from 'react';
// import { useSelector } from 'react-redux';
import PageHeader from '../../components/PageHeader';
import MailForms from '../../components/Wepick/mailForms';

const MainFormPage = (props) => {
  // const { permissions, company } = useSelector(
  //   (store) => ({
  //     permissions: store.Profile.permissions,
  //     company: store.Profile.company
  //   }),
  // );
  const [targetPermission, /** setTargetPermission */] = useState({});
  const headerButtons = [];
  return (
    <>
      <PageHeader
        title={"위픽 메일폼 관리"}
        buttons={targetPermission.level > 1 ? headerButtons : []}
      />
      <MailForms />
    </>
  );
};

export default MainFormPage;